import axios from 'axios';

export function verifyCaptchaLawyers(gRecaptchaResponse: string | null) {
  return axios.post('/verify_captcha_lawyers', {
    gRecaptchaResponse,
  });
}

export function verifyCaptcha(gRecaptchaResponse: string | null) {
  return axios.post('/verify_captcha', {
    gRecaptchaResponse,
  });
}
